import {Provider} from '@oilstone/container';
import Registry from '@/services/resources/registry';
import blockquoteModule from "@/shared/modules/blockquote";
import containerModule from '@/shared/modules/container';
import fullBleedHeroCarouselModule from '@/shared/modules/full-bleed-hero-carousel';
import heroModule from '@/shared/modules/hero';
import heroCarouselModule from '@/shared/modules/hero-carousel';
import heroWithCardModule from '@/shared/modules/hero-with-card';
import heroContactModule from '@/shared/modules/hero-contact';
import heroTextModule from '@/shared/modules/hero-text';
import imageModule from '@/shared/modules/image';
import imageCarouselModule from '@/shared/modules/image-carousel';
import richTextModule from '@/shared/modules/richtext';
import videoModule from '@/shared/modules/video';
import podcastModule from '@/shared/modules/podcast';
import noticeModule from '@/shared/modules/notice';
import pulloutModule from '@/shared/modules/pullout';
import locationsModule from '@/shared/modules/locations';
import newsAndViewsModule from '@/shared/modules/news-and-views';
import modulePosterBoard from '@/shared/modules/poster-board';
import badgesModule from '@/shared/modules/badges'

export default new Provider().register(container => {
    container.singleton('moduleRegistry', () => {
        const registry = new Registry();

        registry
            .add(blockquoteModule)
            .add(containerModule)
            .add(heroModule)
            .add(heroCarouselModule)
            .add(fullBleedHeroCarouselModule)
            .add(heroWithCardModule)
            .add(heroContactModule)
            .add(heroTextModule)
            .add(imageModule)
            .add(imageCarouselModule)
            .add(richTextModule)
            .add(videoModule)
            .add(podcastModule)
            .add(noticeModule)
            .add(pulloutModule)
            .add(locationsModule)
            .add(newsAndViewsModule)
            .add(modulePosterBoard)
            .add(badgesModule);

        return registry;
    });
});
